import { operationTypeConstants as C } from '../actions/constants'

const initialState = {
    operations: [],
    loading: false,
    error: null,
}

const operationTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case C.LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case C.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                operations: action.payload || [],
            }

        case C.LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }

        default:
            return state
    }
}

export default operationTypeReducer